import { useMutation } from '@tanstack/react-query';

import * as cmsService from '../../services';

export const useUploadAsset = ({ options = {} } = {}) =>
  useMutation(formData => cmsService.uploadAsset(formData), options);
